export interface RecognizedAlternative {
    transcript: string;
}

export interface RecognizedResult {
    isFinal: boolean;
    0: RecognizedAlternative;
}

export interface SpeechRecognizerResultEvent {
    results: ArrayLike<RecognizedResult>;
}

export interface SpeechRecognizerErrorEvent {
    error: string;
    message: string;
}

export interface SpeechRecognizer {
    continuous: boolean;
    interimResults: boolean;
    lang: string;
    onresult: ((event: SpeechRecognizerResultEvent) => void) | null;
    onerror: ((event: SpeechRecognizerErrorEvent) => void) | null;
    onend: (() => void) | null;
    start: () => void;
    stop: () => void;
    abort: () => void;
}

export type SpeechRecognizerConstructor = new () => SpeechRecognizer;

type SpeechWindow = Window & {
    SpeechRecognition?: SpeechRecognizerConstructor;
    webkitSpeechRecognition?: SpeechRecognizerConstructor;
};

export const getSpeechRecognitionConstructor = (): SpeechRecognizerConstructor | null => {
    if (typeof window === "undefined") {
        return null;
    }
    const speechWindow = window as SpeechWindow;
    return speechWindow.SpeechRecognition ?? speechWindow.webkitSpeechRecognition ?? null;
};

const mobilePlatform = /iPhone|iPad|iPod|Android/i;
const chromiumBrowser = /Chrome\/|Chromium\/|CriOS\/|Edg\//;
const safariBrowser = /Safari\//;

export const speechEnginePunctuates = (userAgent: string): boolean => {
    if (mobilePlatform.test(userAgent)) {
        return true;
    }
    return safariBrowser.test(userAgent) && !chromiumBrowser.test(userAgent);
};

export type Connectivity = "online" | "offline";

export const currentConnectivity = (): Connectivity =>
    navigator.onLine ? "online" : "offline";

export const usesMicrosoftSpeechService = (userAgent: string): boolean =>
    /Edg\//.test(userAgent);

export const prefersSingleUtteranceSessions = (userAgent: string): boolean =>
    /Android/i.test(userAgent);
